module.exports = __webpack_public_path__ + "img/customer@2x.d548945f.webp";